<!-- this element is required to load table CSS. When angular material add better way to render static tables,
     feel free to drop it. Or just render details as a list. -->
<table mat-table style="display: none">
  <tr mat-header-row *matHeaderRowDef="[]"></tr>
  <tr mat-row *matRowDef="let row; columns: []"></tr>
</table>

<table class="mat-mdc-table">
  <tbody>
    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Code</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        <a [routerLink]="['/app/client-accounts/view', agreement().ClientCode]"> {{ agreement().ClientCode }} </a>
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Name</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ client()?.ClientName }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Product Number</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        <a [routerLink]="['/app/products/view', agreement().JobNumber]"> {{ agreement().JobNumber }} </a>
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Agreement Number</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().AgreementNumber }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Title</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().Title }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Product Owner</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().ProductOwner }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Jira Title</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        <a href="{{ jira.link(agreement().JiraTitle) }}" target="_blank">{{ agreement().JiraTitle }}</a>
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Service Type</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().ServiceType }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Start Date</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().StartDate | date: 'dd/MM/y' }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">End Date</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().EndDate | date: 'dd/MM/y' }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Next Invoice</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        <div class="cell-actions">
          {{ agreement().NextInvoiceDate | date: 'dd/MM/y' }}
          <span class="spacer"></span>
          @if (canChangeInvoiceDate()) {
            <button matMiniFab matTooltip="Update invoice date" (click)="changeInvoiceDate()">
              <mat-icon>restore</mat-icon>
            </button>
          }
        </div>
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Billing Cycle</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().BillingCycle }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Status</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().Status }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Total Contract Cost</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().InvoiceAmount | number }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Infrastructure Amount</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().HostingAmount || 0 | number }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Service Amount</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().ServiceAmount || 0 | number }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Support & Maintenance Amount</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().SupportMaintenanceAmount || 0 | number }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Has SLA</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().HasSLA ? 'Yes' : 'No' }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Expiration period</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().ExtendedLifetime ? '12 months' : '3 months' }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Support Hours</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().SupportHours || 0 }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Jira Licenses</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().JiraLicence || 0 }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Commissionable</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().Commissionable ? 'Yes' : 'No' }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Cost per story point</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        @if (completedSp()) {
          <div class="cell-actions">
            ${{ projectValue() / completedSp() | number: '.0-2' }} per SP

            <span class="spacer"></span>
            <mat-chip> ${{ projectValue() | number }} / {{ completedSp() }}SP </mat-chip>
          </div>
        } @else {
          -
        }
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Budget Note</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().BudgetNote || '' }}</td>
    </tr>

    @if (agreement().Notes) {
      <tr class="mat-mdc-row">
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Notes</th>
        <td class="mat-mdc-cell mdc-data-table__cell">{{ agreement().Notes }}</td>
      </tr>
    }
    @if (client()?.XeroId) {
      <tr class="mat-mdc-row">
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Xero ID</th>
        <td class="mat-mdc-cell mdc-data-table__cell">
          <a
            target="_blank"
            href="https://go.xero.com/Contacts/View.aspx?contactID={{ client()?.XeroId }}"
            title="{{ client()?.XeroId }}"
          >
            {{ client()?.XeroId }}
          </a>
        </td>
      </tr>
    }
  </tbody>
</table>
